import { h, Component } from 'preact';
import Three from '../../gemThree/gemThree';
import Loadingbar from '../../../loadingbar/loadingbar';
import ZoomControls from '../../gemZoomControls/zoomcontrols';
import config from '../../../../config/config.json';
import i18n from '../../../../config/i18n.json';
import s from '../scss/gemComponentsView.scss';

export default class GemInteriorView extends Component {
  constructor(props) {
    super(props);

    let showLayer = true;

    // look for URL param "nl" to disable the 360 layer
    const queryParams = new URLSearchParams(window.location.search)
    for (const [key] of queryParams) {
      if (key === 'nl') {
        showLayer = false;
      }
    }

    this.state = {
      loading: {
        imagesLoaded: 0,
        isLoaded: false,
        percentLoaded: 0
      },
      zooming: 0.5,
      zoom: true,
      showLayer: showLayer
    };

    this.getVPwidth();

    this.setUrlParams();
  }

  componentDidMount() {
    window.addEventListener('orientationchange', this.getVPwidth);
    window.addEventListener('resize', this.getVPwidth);
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.getVPwidth);
    window.removeEventListener('resize', this.getVPwidth);
  }

  setUrlParams = () => {
    // all Carline and Request stuff are set to state
    let url = window.location.href.split('?')[0];
    url = url.split('#')[0];
    // remove index.html if in url
    const noIndex = url.replace('index.html', '');
    // regex to find the correct parameters to build imagePath
    const path_regex = new RegExp(
      /([A-Za-z\d]*)\/([A-Z]{2,3})\/([a-z]{2})\/([a-zA-Z_\d]{3,10})/
    );
    const params = url.split(path_regex);

    const carline = params[1];
    const country = params[2];
    const lang = params[3];
    // body style is a combination of {trim}_{color}
    const bodyStyle = params[4];
    const mobile = params[5];
    const imgPath =
      carline +
      '/' +
      country +
      '/' +
      lang +
      '/' +
      bodyStyle +
      mobile + '/';
    const absPath =
      process.env.NODE_ENV === 'production'
        ? noIndex
        : `${window.location.origin}/`;

    const clearMobileParam = mobile.split("/")
    this.setState({
      imgPath,
      carline,
      country,
      lang,
      absPath,
      mobile: clearMobileParam[1] === 'mobile' ? clearMobileParam[1] : ''
    });

    const marketConfig = config.array.find(
      market => market.market === `${country}_${lang}`
    );
    marketConfig &&
      marketConfig[carline] &&
      this.getConfig(marketConfig[carline]);
      this.setTranslations(lang);
  };

  getConfig = marketConfig => {
    // find defaultThumb Index
    const defaultThumbIndex = marketConfig.findIndex(thumb => thumb.default);
    // set defaultThumb to state
    // get carline config from market
    this.setState({
      interior: {
        config: marketConfig,
        index: defaultThumbIndex
      }
    });
  };

  getVPwidth = () => {
    this.setState({
      vw: Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      ),
      vh: Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      )
    });
  };

  loadHandling = (amount, increment = false) => {
    this.setState(prevState => ({loading: {
        imagesLoaded: increment ? prevState.loading.imagesLoaded + 1 : prevState.loading.imagesLoaded,
        percentLoaded: (100 / amount) * (increment ? prevState.loading.imagesLoaded + 1 : prevState.loading.imagesLoaded),
        isLoaded: (100 / amount) * (increment ? prevState.loading.imagesLoaded + 1 : prevState.loading.imagesLoaded) === 100
    }, ...prevState.loading}))
  };

  handleZoomClicked = factor => {
    this.removeLayer();
    this.setState({ zooming: factor, zoom: !this.state.zoom });
  };

  handleZoomStopped = () => {
    this.setState({ zooming: 0 });
  };

  removeLayer = () => {
    this.setState({showLayer: false});
  };

  setTranslations = lang => {
    const translations = {};
    for (const key in i18n) {
      translations[key] = i18n[key][lang] || false;
    }
    this.setState({translations});
  }

  render() {
    const {
      absPath,
      imgPath,
      interior,
      loading,
      vw,
    } = this.state;
    const size = document.body.offsetHeight;

    const input = (
      <div
        id="interior"
      >
        {!this.state.mobile && this.state.loading.isLoaded && <ZoomControls
          zoomClicked={this.handleZoomClicked}
          zoomFactor={this.state.zooming}
          zoomStatus={this.state.zoom}
        />}
        {this.state.showLayer && this.state.loading.isLoaded && <div className={s.layer}>
          <div className={s.threesixtyIcon} />
        </div>}

        <Three
          stageWidth={vw}
          stageHeight={size}
          loadHandling={this.loadHandling}
          removeLayer={this.removeLayer}
          imgPath={imgPath}
          interior={interior}
          absPath={absPath}
          zoomStopped={this.handleZoomStopped}
          zoomFactor={this.state.zooming}
          isInteriorOnly={this.isInteriorOnly}
          carline={this.state.carline}
        />
      </div>
    );

    return (
      <div id="app">
        {loading.percentLoaded < 100 && (
          <Loadingbar percent={loading.percentLoaded} />
        )}
        {input}
      </div>
    );
  }
}
